// @format
import React from 'react';
import styled from 'styled-components';
import Viewer from './Viewer';
import colors from '../constants/colors';
import { withRouter } from 'react-router';
import qs from 'query-string';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: ${colors.RED};
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;

  @media (max-width: 800px) {
    display: block;
    height: auto;
  }
`;

const ItemWrapper = styled.a`
  color: ${prop => (prop.active ? 'white' : '#a8a9ad')}
  font-size: 21px;
  font-weight: bold;
  text-decoration: none;

  @media (max-width: 800px) {
    display: block;
		padding-top: 6px;
		padding-bottom: 6px;
  }
`;

export const Item = ({ children, pdf, enrollment, trust }) => {
  const { url } = qs.parse(window.location.search);
  const regex = new RegExp(pdf);

  return (
    <ItemWrapper
      active={regex.test(url)}
      href={`/view${enrollment ? '/enrollment' : ''}${
        trust ? '/trust' : ''
      }?url=${process.env.PUBLIC_URL}/${encodeURIComponent(pdf)}`}
    >
      {children}
    </ItemWrapper>
  );
};

export const Home = () => (
  <ItemWrapper active={false} href="/">
    Home
  </ItemWrapper>
);

export default withRouter(() => (
  <Wrapper>
    <Header>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.COMPLIANCE.pdf">
        Compliance
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.WELLNESS.pdf">
        Wellness
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.PHARMACY.pdf">
        Annual Pharmacy Updates
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.TR.MEETING.pdf">
        Annual Trustor Meeting
      </Item>
      <Item trust pdf="pdf/RETA.lifecycle.trust.management.MANAGEMENT.pdf">
        Account Management
      </Item>
      <Home />
    </Header>
    <Viewer />
  </Wrapper>
));
